import React from 'react';
import { Link } from 'react-router-dom'

import GameImage from './GameImage'
import ScoreList from './ScoreList'

import GameList from '../data/GameList'  // HAX!!!

const FeedItem = (props) => {
  const event = props.event;
  const eventlink = '/eventinfo/' + event.matchId;
  let gameImage = '';
  if (props.includeImages !== false) {
    gameImage = <GameImage game={GameList[event.gameId]} />;
  }
  return (
    <div key={event.gameId} className="feeditem">
      {gameImage}
      {ScoreList(event.scores)}
      <Link to={eventlink}>See full scorebook</Link>
    </div>
  );
}

export default FeedItem;



// WEBPACK FOOTER //
// ./src/components/FeedItem.js